import styled from 'styled-components'
import {
  h1style,
  h2style,
  h3style,
  h4style,
  h5style,
  h6style,
} from '../Heading/Heading.styled'
import { linkStyle } from '../Link/Link'
import { boldStyle, italicStyle } from '../Paragraph/Paragraph'
import { liStyle, olStyle, ulStyle } from '../List/List.syled'
import { tableStyle, tdStyle, thStyle, trStyle } from '../Table/Table.styled'
import pxToRem from '../../utils/pxToRem'

export const StyledContainer = styled.div`
  h1 {
    ${h1style}
  }

  h2 {
    ${h2style}
  }

  h3 {
    ${h3style}
  }

  h4 {
    ${h4style}
  }

  h5 {
    ${h5style}
  }

  h6 {
    ${h6style}
  }

  p {
    margin-bottom: ${pxToRem(10)};
    padding-bottom: ${pxToRem(1)};
  }

  a {
    padding-right: 0;
    padding-left: 0;
    font-weight: 700;
    text-decoration: underline;
    text-decoration-color: ${({ theme }) => theme.colors.primary.blue};
  }

  a span {
    color: #000000 !important;
  }

  b,
  strong {
    ${boldStyle}
  }

  i {
    ${italicStyle}
  }

  li {
    ${liStyle}
  }

  ol {
    ${olStyle}
  }

  ul {
    display: block;
    margin-right: 0;
    margin-bottom: 1 em;
    margin-left: 0;
    padding-left: 40px;
    list-style-type: disc;
  }

  table {
    ${tableStyle}
  }

  td {
    ${tdStyle}
  }

  th {
    ${thStyle}
  }

  tr {
    ${trStyle}
  }

  blockquote {
    display: block;
    margin-top: ${pxToRem(16)};
    margin-right: ${pxToRem(40)};
    margin-bottom: ${pxToRem(16)};
    border-left: ${pxToRem(5)} solid #ccc;
    padding-left: ${pxToRem(40)};
  }

  .image > img {
    display: block;
    margin-right: auto;
    margin-left: auto;
  }

  .image-style-side {
    float: right;
    margin-left: ${pxToRem(24)};
    max-width: 50%;
  }

  .text-tiny {
    font-size: 0.7rem;
  }

  .text-small {
    font-size: 0.8rem;
  }

  .text-big {
    font-size: 1.4rem;
  }

  .text-huge {
    font-size: 1.8rem;
  }
`
